/**
 * Symbol Names Mapping - Maps trading symbols to their full company/asset names
 * Used throughout the app to display human-readable names instead of tickers
 */

export const SYMBOL_NAMES = {
  // ==================== STOCKS - US ====================
  // Tech Giants
  "NASDAQ:GOOGL": "Alphabet (Google)",
  "NASDAQ:GOOG": "Alphabet (Google)",
  "GOOGL": "Alphabet (Google)",
  "NASDAQ:AAPL": "Apple",
  "AAPL": "Apple",
  "NASDAQ:MSFT": "Microsoft",
  "MSFT": "Microsoft",
  "NASDAQ:AMZN": "Amazon",
  "AMZN": "Amazon",
  "NASDAQ:META": "Meta (Facebook)",
  "META": "Meta (Facebook)",
  "NASDAQ:TSLA": "Tesla",
  "TSLA": "Tesla",
  "NASDAQ:NVDA": "Nvidia",
  "NVDA": "Nvidia",
  "NASDAQ:AMD": "AMD",
  "AMD": "AMD",
  "NASDAQ:INTC": "Intel",
  "INTC": "Intel",
  "NASDAQ:NFLX": "Netflix",
  "NFLX": "Netflix",
  
  // Finance
  "NYSE:V": "Visa",
  "V": "Visa",
  "NYSE:MA": "Mastercard",
  "MA": "Mastercard",
  "NYSE:JPM": "JPMorgan Chase",
  "JPM": "JPMorgan Chase",
  "NYSE:BAC": "Bank of America",
  "BAC": "Bank of America",
  "NYSE:GS": "Goldman Sachs",
  "GS": "Goldman Sachs",
  
  // Tech / Software
  "NYSE:PLTR": "Palantir",
  "PLTR": "Palantir",
  "NASDAQ:MSTR": "MicroStrategy",
  "MSTR": "MicroStrategy",
  "NASDAQ:SOFI": "SoFi",
  "SOFI": "SoFi",
  "NYSE:RDDT": "Reddit",
  "RDDT": "Reddit",
  "NASDAQ:MU": "Micron Technology",
  "MU": "Micron Technology",
  "NASDAQ:MRVL": "Marvell Technology",
  "MRVL": "Marvell Technology",
  "NYSE:VRT": "Vertiv",
  "VRT": "Vertiv",
  "NASDAQ:IREN": "Iris Energy",
  "IREN": "Iris Energy",
  "NASDAQ:RKLB": "Rocket Lab",
  "RKLB": "Rocket Lab",
  
  // Energy
  "NYSE:XOM": "ExxonMobil",
  "XOM": "ExxonMobil",
  "NYSE:CVX": "Chevron",
  "CVX": "Chevron",
  "NYSE:CCJ": "Cameco (Uranium)",
  "CCJ": "Cameco (Uranium)",
  
  // Defense & Aerospace
  "NYSE:NOC": "Northrop Grumman",
  "NOC": "Northrop Grumman",
  "NYSE:LMT": "Lockheed Martin",
  "LMT": "Lockheed Martin",
  "NYSE:RTX": "RTX (Raytheon)",
  "RTX": "RTX (Raytheon)",
  "NYSE:GD": "General Dynamics",
  "GD": "General Dynamics",
  "NYSE:BA": "Boeing",
  "BA": "Boeing",
  
  // Healthcare / Pharma
  "NYSE:NVO": "Novo Nordisk",
  "NVO": "Novo Nordisk",
  "CSE:NOVO-B": "Novo Nordisk",
  "NOVO-B": "Novo Nordisk",
  "NYSE:LLY": "Eli Lilly",
  "LLY": "Eli Lilly",
  "NYSE:JNJ": "Johnson & Johnson",
  "JNJ": "Johnson & Johnson",
  "NYSE:PFE": "Pfizer",
  "PFE": "Pfizer",
  "NYSE:UNH": "UnitedHealth",
  "UNH": "UnitedHealth",
  
  // Chinese / Asian
  "NYSE:BABA": "Alibaba",
  "BABA": "Alibaba",
  "NYSE:XPEV": "XPeng",
  "XPEV": "XPeng",
  "NYSE:NIO": "NIO",
  "NIO": "NIO",
  "NYSE:JD": "JD.com",
  "JD": "JD.com",
  "HKEX:0700": "Tencent Holdings",
  "0700": "Tencent Holdings",
  "TCEHY": "Tencent Holdings",
  "OTC:TCEHY": "Tencent Holdings",
  "HKEX:1211": "BYD Company",
  "1211.HK": "BYD Company",
  "1211": "BYD Company",
  
  // Fintech / Trading
  "NASDAQ:HOOD": "Robinhood Markets",
  "HOOD": "Robinhood Markets",
  
  // Cloud / SaaS
  "NYSE:NOW": "ServiceNow",
  "NOW": "ServiceNow",
  
  // Mining / Resources
  "NYSE:NEM": "Newmont (Or)",
  "NEM": "Newmont (Or)",
  
  // Mexican / Other International
  "BMV:ETLN": "Etalon Group",
  "ETLN.MX": "Etalon Group",
  "ETLN": "Etalon Group",
  
  // ==================== STOCKS - EUROPE ====================
  // France
  "EURONEXT:TTE": "TotalEnergies",
  "TTE": "TotalEnergies",
  "EURONEXT:MC": "LVMH",
  "MC": "LVMH",
  "EURONEXT:DG": "Vinci",
  "DG": "Vinci",
  "EURONEXT:SU": "Schneider Electric",
  "SU": "Schneider Electric",
  "EURONEXT:SAF": "Safran",
  "SAF": "Safran",
  "EURONEXT:HO": "Thales",
  "HO": "Thales",
  "EURONEXT:AIR": "Airbus",
  "AIR": "Airbus",
  "EURONEXT:OR": "L'Oréal",
  "OR": "L'Oréal",
  "EURONEXT:SAN": "Sanofi",
  "SAN": "Sanofi",
  "EURONEXT:BNP": "BNP Paribas",
  "BNP": "BNP Paribas",
  "EURONEXT:DFNS": "Drone Volt",
  "DFNS": "Drone Volt",
  "EURONEXT:DFNSCHF": "Drone Volt CHF",
  
  // ==================== CRYPTO ====================
  // Major
  "BINANCE:BTCUSDT": "Bitcoin",
  "BTCUSDT": "Bitcoin",
  "BTC": "Bitcoin",
  "CCC:BTC-USD": "Bitcoin",
  "BINANCE:ETHUSDT": "Ethereum",
  "ETHUSDT": "Ethereum",
  "ETH": "Ethereum",
  "CCC:ETH-USD": "Ethereum",
  "BINANCE:SOLUSDT": "Solana",
  "SOLUSDT": "Solana",
  "SOL": "Solana",
  "CCC:SOL-USD": "Solana",
  "CCC:BNB-USD": "BNB",
  "BNBUSDT": "BNB",
  "BNB": "BNB",
  
  // Altcoins
  "BINANCE:XRPUSDT": "Ripple (XRP)",
  "XRPUSDT": "Ripple (XRP)",
  "XRP": "Ripple (XRP)",
  "CCC:XRP-USD": "Ripple (XRP)",
  "BINANCE:ADAUSDT": "Cardano",
  "ADAUSDT": "Cardano",
  "ADA": "Cardano",
  "CCC:ADA-USD": "Cardano",
  "BINANCE:DOGEUSDT": "Dogecoin",
  "DOGEUSDT": "Dogecoin",
  "DOGE": "Dogecoin",
  "CCC:DOGE-USD": "Dogecoin",
  "BINANCE:AVAXUSDT": "Avalanche",
  "AVAXUSDT": "Avalanche",
  "AVAX": "Avalanche",
  "CCC:AVAX-USD": "Avalanche",
  "BINANCE:LINKUSDT": "Chainlink",
  "LINKUSDT": "Chainlink",
  "LINK": "Chainlink",
  "CCC:LINK-USD": "Chainlink",
  "BINANCE:DOTUSDT": "Polkadot",
  "DOTUSDT": "Polkadot",
  "DOT": "Polkadot",
  "CCC:DOT-USD": "Polkadot",
  "BINANCE:MATICUSDT": "Polygon",
  "MATICUSDT": "Polygon",
  "MATIC": "Polygon",
  "BINANCE:LTCUSDT": "Litecoin",
  "LTCUSDT": "Litecoin",
  "LTC": "Litecoin",
  "CCC:LTC-USD": "Litecoin",
  "BINANCE:UNIUSDT": "Uniswap",
  "UNIUSDT": "Uniswap",
  "UNI": "Uniswap",
  "CCC:UNI7083-USD": "Uniswap",
  "BINANCE:AAVEUSDT": "Aave",
  "AAVEUSDT": "Aave",
  "AAVE": "Aave",
  "BINANCE:ATOMUSDT": "Cosmos",
  "ATOMUSDT": "Cosmos",
  "ATOM": "Cosmos",
  "BINANCE:XLMUSDT": "Stellar",
  "XLMUSDT": "Stellar",
  "XLM": "Stellar",
  "CCC:XLM-USD": "Stellar",
  "BINANCE:VETUSDT": "VeChain",
  "VETUSDT": "VeChain",
  "VET": "VeChain",
  "BINANCE:TRXUSDT": "Tron",
  "TRXUSDT": "Tron",
  "TRX": "Tron",
  "CCC:TRX-USD": "Tron",
  "CCC:CRO-USD": "Cronos",
  "CRO": "Cronos",
  
  // DeFi / New
  "BINANCE:TAOUSDT": "Bittensor (TAO)",
  "TAOUSDT": "Bittensor (TAO)",
  "TAO": "Bittensor (TAO)",
  "BYBIT:HYPEUSDT": "Hyperliquid",
  "HYPEUSDT": "Hyperliquid",
  "HYPE": "Hyperliquid",
  "BINANCE:INJUSDT": "Injective",
  "INJUSDT": "Injective",
  "INJ": "Injective",
  "BINANCE:APTUSDT": "Aptos",
  "APTUSDT": "Aptos",
  "APT": "Aptos",
  "BINANCE:ARBUSDT": "Arbitrum",
  "ARBUSDT": "Arbitrum",
  "ARB": "Arbitrum",
  "BINANCE:OPUSDT": "Optimism",
  "OPUSDT": "Optimism",
  "OP": "Optimism",
  
  // ==================== INDICES ====================
  "TVC:SPX": "S&P 500",
  "SPX": "S&P 500",
  "SP:SPX": "S&P 500",
  "TVC:NDQ": "Nasdaq 100",
  "NDQ": "Nasdaq 100",
  "TVC:DJI": "Dow Jones",
  "DJI": "Dow Jones",
  "TVC:VIX": "VIX (Volatilité)",
  "VIX": "VIX (Volatilité)",
  "CAPITALCOM:US100": "Nasdaq 100",
  "US100": "Nasdaq 100",
  "CAPITALCOM:US500": "S&P 500",
  "US500": "S&P 500",
  "CAPITALCOM:US30": "Dow Jones 30",
  "US30": "Dow Jones 30",
  "CAPITALCOM:DE40": "DAX 40",
  "DE40": "DAX 40",
  "CAPITALCOM:FR40": "CAC 40",
  "FR40": "CAC 40",
  
  // ==================== COMMODITIES ====================
  "TVC:GOLD": "Or (Gold)",
  "GOLD": "Or (Gold)",
  "XAUUSD": "Or (Gold)",
  "TVC:SILVER": "Argent (Silver)",
  "SILVER": "Argent (Silver)",
  "XAGUSD": "Argent (Silver)",
  "TVC:USOIL": "Pétrole WTI",
  "USOIL": "Pétrole WTI",
  "TVC:UKOIL": "Pétrole Brent",
  "UKOIL": "Pétrole Brent",
  "COMEX:HG1!": "Cuivre",
  "HG1!": "Cuivre",
  "NYMEX:NG1!": "Gaz Naturel",
  "NG1!": "Gaz Naturel",
  
  // ==================== FOREX ====================
  "FX:EURUSD": "Euro/Dollar",
  "EURUSD": "Euro/Dollar",
  "FX:GBPUSD": "Livre/Dollar",
  "GBPUSD": "Livre/Dollar",
  "FX:USDJPY": "Dollar/Yen",
  "USDJPY": "Dollar/Yen",
  "FX:USDCHF": "Dollar/Franc Suisse",
  "USDCHF": "Dollar/Franc Suisse",
  "FX:AUDUSD": "Dollar Australien/USD",
  "AUDUSD": "Dollar Australien/USD",
  "FX:USDCAD": "Dollar/Dollar Canadien",
  "USDCAD": "Dollar/Dollar Canadien",
  
  // ==================== ETFs ====================
  "AMEX:SPY": "SPDR S&P 500 ETF",
  "SPY": "SPDR S&P 500 ETF",
  "AMEX:QQQ": "Invesco Nasdaq ETF",
  "QQQ": "Invesco Nasdaq ETF",
  "AMEX:IWM": "iShares Russell 2000",
  "IWM": "iShares Russell 2000",
  "AMEX:GLD": "SPDR Gold Trust",
  "GLD": "SPDR Gold Trust",
  "AMEX:SLV": "iShares Silver Trust",
  "SLV": "iShares Silver Trust",
  "FP:PAEEM": "Amundi MSCI EM",
  "PAEEM": "Amundi MSCI EM",
};

/**
 * Get the full name of a symbol
 * @param {string} symbol - The trading symbol (e.g., "NASDAQ:PLTR", "PLTR", "BINANCE:ETHUSDT")
 * @returns {string} - The full name (e.g., "Palantir", "Ethereum") or the original symbol if not found
 */
export const getSymbolName = (symbol) => {
  if (!symbol) return '';
  
  // Try exact match first
  if (SYMBOL_NAMES[symbol]) {
    return SYMBOL_NAMES[symbol];
  }
  
  // Try without exchange prefix
  const withoutExchange = symbol.includes(':') ? symbol.split(':')[1] : symbol;
  if (SYMBOL_NAMES[withoutExchange]) {
    return SYMBOL_NAMES[withoutExchange];
  }
  
  // Try uppercase
  const upper = symbol.toUpperCase();
  if (SYMBOL_NAMES[upper]) {
    return SYMBOL_NAMES[upper];
  }
  
  // Try to clean crypto symbols (remove USDT suffix)
  const cleanCrypto = withoutExchange.replace(/USDT$|USD$|-USD$/i, '');
  if (SYMBOL_NAMES[cleanCrypto]) {
    return SYMBOL_NAMES[cleanCrypto];
  }
  
  // Return the ticker part as fallback
  return withoutExchange;
};

/**
 * Get both the name and the ticker for display
 * @param {string} symbol - The trading symbol
 * @returns {{name: string, ticker: string, exchange: string}} 
 */
export const getSymbolInfo = (symbol) => {
  if (!symbol) return { name: '', ticker: '', exchange: '' };
  
  const parts = symbol.split(':');
  const exchange = parts.length > 1 ? parts[0] : '';
  const ticker = parts.length > 1 ? parts[1] : symbol;
  const name = getSymbolName(symbol);
  
  return { name, ticker, exchange };
};

export default SYMBOL_NAMES;
